/* eslint-disable max-len */
import ApplicationStore from '../utils/localStorageUtil';

const successCaseCode = [200, 201];

const _fetchService = (PATH, serviceMethod, data, successCallback, errorCallBack) => {
  const { user_token, userDetails } = ApplicationStore().getStorage('userDetails');
  // const END_POINT = 'https://ai.wisething.in/yenepoya/api/';

// const END_POINT = 'https://varmatrix.com/YENEPOYA_2025/api/';
// const END_POINT = ' http://192.168.1.85:8006/api/';
const END_POINT = ' https://insightsx.in/SahyadriHostel/api/';

// const END_POINT = 'https://insightsx.in/yenepoya/api/'
// const END_POINT = 'https://insightsx.in/yenepoya_blr/api/'



  const { emailId, userRole } = userDetails;
  // https://blr.wisething.in/yenepoya/api/
  // https://wisething.in/yenepoya/api/
  const headers = {
    'Content-Type': 'application/json',
    authorization: `Bearer ${user_token}`,
    // companyCode: `${companyCode}`,
    userId: `${emailId}`,
    userRole: `${userRole}`,
    branch:`${userDetails.branch}`,
    location:`${userDetails.location}`,
    email:`${userDetails.email}`,
  };
  const body = (serviceMethod === 'GET') || (serviceMethod === 'DELETE') ? {} : { body: JSON.stringify(data) };

  const bodyParameters = {
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    headers,
    ...body,
  };

  const bodyObject = {
    method: serviceMethod,
    ...bodyParameters,
  };

  return fetch(END_POINT + PATH, bodyObject)
    .then((response) => {
      if (successCaseCode.indexOf(response.status) > -1) {
        return response.json();
      }
      // eslint-disable-next-line no-throw-literal
      throw {
        errorStatus: response.status,
        errorObject: response.json(),
      };
    })
    .then((dataResponse) => successCallback(dataResponse))
    .catch((error) => {
      error.errorObject.then((errorResponse) => {
        if (error.errorStatus === 400 && errorResponse.message === 'Token is  required') {
          ApplicationStore().clearStorage();
          location.reload();
        }
        errorCallBack(error.errorStatus, errorResponse.message, errorResponse);
      });
    });
};

export const LoginService = (data) => {
  const PATH = 'login';
  // const END_POINT = 'https://ai.wisething.in/yenepoya/api/';

  // const END_POINT = 'https://varmatrix.com/yenepoya/api/';
// const END_POINT ='https://varmatrix.com/YENEPOYA_2025/api/';
// const END_POINT = ' http://192.168.1.85:8006/api/';
const END_POINT = ' https://insightsx.in/SahyadriHostel/api/';
// const END_POINT = 'https://insightsx.in/yenepoya/api/';
// const END_POINT = 'https://insightsx.in/yenepoya_blr/api/'



  const SERVICE_METHOD = 'POST';
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  return fetch(END_POINT + PATH, {
    method: SERVICE_METHOD,
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers,
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });
};

export const LogoutService = (successCallback, errorCallBack) => _fetchService('logout', 'POST', {}, successCallback, errorCallBack);

/////----- Location------///////

export const LocationAdd = (data, successCallback, errorCallBack) => _fetchService('location/add', 'POST', data, successCallback, errorCallBack);

export const LocationUpdate = (data, successCallback, errorCallBack) => _fetchService(`location/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const LocationDelete = (id, successCallback, errorCallBack) => _fetchService(`location/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const LocationShowdata = (successCallback, errorCallBack) => _fetchService('location/showData', 'GET', {}, successCallback, errorCallBack);

/////-----Add Shift-----/////

export const ShiftTimeAdd = (data, successCallback, errorCallBack) => _fetchService('shift/add', 'POST', data, successCallback, errorCallBack);

export const ShiftTimeUpdate = (data, successCallback, errorCallBack) => _fetchService(`shift/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const ShiftTimeDelete = (id, successCallback, errorCallBack) => _fetchService(`shift/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const ShiftTimeShowdata = (successCallback, errorCallBack) => _fetchService('shift/showData', 'GET', {}, successCallback, errorCallBack);

//////------Branch-------///////

export const BranchAdd = (data, successCallback, errorCallBack) => _fetchService('branch/add', 'POST', data, successCallback, errorCallBack);

export const BranchUpdate = (data, successCallback, errorCallBack) => _fetchService(`branch/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const BranchDelete = (id, successCallback, errorCallBack) => _fetchService(`branch/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const BranchShowdata = (successCallback, errorCallBack) => _fetchService('branch/showData', 'GET', {}, successCallback, errorCallBack);

/////-----Class-----//////

export const ClassNameAdd = (data, successCallback, errorCallBack) => _fetchService('class/add', 'POST', data, successCallback, errorCallBack);

export const ClassNameUpdate = (data, successCallback, errorCallBack) => _fetchService(`class/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const ClassNameDelete = (id, successCallback, errorCallBack) => _fetchService(`class/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const ClassNameShowdata = (successCallback, errorCallBack) => _fetchService('class/showData', 'GET', {}, successCallback, errorCallBack);

export const FetchBranchShowData = (data,successCallback, errorCallBack) => _fetchService(`getBranch/${data.id}`, 'GET', {}, successCallback, errorCallBack);

///// Specialization-----////

export const SpecializationShowdata = (successCallback, errorCallBack) => _fetchService('specialization/showData', 'GET', {}, successCallback, errorCallBack);

export const SpecializationDelete = (id, successCallback, errorCallBack) => _fetchService(`specialization/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const SpecializationAdd = (data, successCallback, errorCallBack) => _fetchService('specialization/add', 'POST', data, successCallback, errorCallBack);

export const SpecializationUpdate = (data, successCallback, errorCallBack) => _fetchService(`specialization/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

/////-----Semester------/////

export const SemesterShowdata = (successCallback, errorCallBack) => _fetchService('semester/showData', 'GET', {}, successCallback, errorCallBack);

export const SemesterDelete = (id, successCallback, errorCallBack) => _fetchService(`semester/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const SemesterAdd = (data, successCallback, errorCallBack) => _fetchService('semester/add', 'POST', data, successCallback, errorCallBack);

export const SemesterUpdate = (data, successCallback, errorCallBack) => _fetchService(`semester/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const FetchSpecializationShowData = (data,successCallback, errorCallBack) => _fetchService(`getSpecilize/${data.id}`, 'GET', {}, successCallback, errorCallBack);

///////-----Section------////

export const SectionAdd = (data, successCallback, errorCallBack) => _fetchService('section/add', 'POST', data, successCallback, errorCallBack);

export const SectionUpdate = (data, successCallback, errorCallBack) => _fetchService(`section/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const SectionDelete = (id, successCallback, errorCallBack) => _fetchService(`section/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const SectionShowdata = (successCallback, errorCallBack) => _fetchService('section/showData', 'GET', {}, successCallback, errorCallBack);

//////-----Classroom-----/////

export const StudentClassroomAdd = (data, successCallback, errorCallBack) => _fetchService('classRoom/add', 'POST', data, successCallback, errorCallBack);

export const StudentClassroomUpdate = (data, successCallback, errorCallBack) => _fetchService(`classRoom/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const StudentClassroomDelete = (id, successCallback, errorCallBack) => _fetchService(`classRoom/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const StudentClassroomShowdata = (successCallback, errorCallBack) => _fetchService('classRoom/showData', 'GET', {}, successCallback, errorCallBack);

/////-----Subject----/////

export const SubjectShowdata = (successCallback, errorCallBack) => _fetchService('classSub/showData', 'GET', {}, successCallback, errorCallBack);

export const SubjectDelete = (id, successCallback, errorCallBack) => _fetchService(`classSub/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const SubjectAdd = (data, successCallback, errorCallBack) => _fetchService('classSub/add', 'POST', data, successCallback, errorCallBack);

export const SubjectUpdate = (data, successCallback, errorCallBack) => _fetchService(`classSub/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const FetchSemesterShowData = (data,successCallback, errorCallBack) => _fetchService(`getSemester/${data.id}`, 'GET', {}, successCallback, errorCallBack);

export const MastSubShowData = (data,successCallback, errorCallBack) => _fetchService('MastSub/showData', 'POST', data, successCallback, errorCallBack);

export const MastSubAdd = (data,successCallback, errorCallBack) => _fetchService('MastSub/add', 'POST', data, successCallback, errorCallBack);

export const MastSubUpdate = (data, successCallback, errorCallBack) => _fetchService(`MastSub/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const MastSubDelete = (data, successCallback, errorCallBack) => _fetchService(`MastSub/${data.id}/delete`, 'POST', data, successCallback, errorCallBack);

export const MastSubCancel = (data,successCallback, errorCallBack) => _fetchService('MastSub/cancel', 'POST', data, successCallback, errorCallBack);

/////-----Class Type-----//////
export const ClasstypeShowdata = (successCallback, errorCallBack) => _fetchService('classType/showData', 'GET', {}, successCallback, errorCallBack);

export const ClasstypeAdd = (data, successCallback, errorCallBack) => _fetchService('classType/add', 'POST', data, successCallback, errorCallBack);

export const ClasstypeUpdate = (data, successCallback, errorCallBack) => _fetchService(`classType/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const ClasstypeDelete = (data, successCallback, errorCallBack) => _fetchService(`classType/${data.id}/delete`, 'POST', data, successCallback, errorCallBack);

/////-----Faculty-----//////

export const FacultyAdd = (data, successCallback, errorCallBack) => _fetchService('faculty/add', 'POST', data, successCallback, errorCallBack);

export const FacultyUpdate = (data, successCallback, errorCallBack) => _fetchService(`faculty/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const FacultyDelete = (id, successCallback, errorCallBack) => _fetchService(`faculty/${id}/delete`, 'POST', {}, successCallback, errorCallBack);

export const FacultyShowdata = (successCallback, errorCallBack) => _fetchService('faculty/showData2', 'GET', {}, successCallback, errorCallBack);

export const FacultyEmpno = (successCallback, errorCallBack) => _fetchService('faculty/empId', 'GET', {}, successCallback, errorCallBack);

export const FetchClassNameShowData = (data,successCallback, errorCallBack) => _fetchService(`getClass/${data.id}`, 'GET', {}, successCallback, errorCallBack);

export const FacultyQrData = (data,successCallback, errorCallBack) => _fetchService(`faculty/${data.id}/qrData`, 'GET', {}, successCallback, errorCallBack);

export const FacultyBulkUpload = (data, successCallback, errorCallBack) => _fetchService('faculty/import', 'POST', data, successCallback, errorCallBack);

export const  FetchfacultyLabelService = (successCallback, errorCallBack) => _fetchService('faculty/labelShow', 'GET', {}, successCallback, errorCallBack);

export const  LabelfacultyAddService = (data, successCallback, errorCallBack) => _fetchService('faculty/label', 'POST', data, successCallback, errorCallBack);

export const  LabelDeletService = (id,successCallback, errorCallBack) => _fetchService(`faculty/${id}/labelDelete`, 'POST', {}, successCallback, errorCallBack);

export const FacultyCancel = (data,successCallback, errorCallBack) => _fetchService('semSubject/cancel', 'POST', data, successCallback, errorCallBack);

export const MergedStudentShowdata = (successCallback, errorCallBack) => _fetchService('showMergedStudentsSubject', 'GET', {}, successCallback, errorCallBack);

export const MergedStudentDelete = (
  subjectId, sectionId, semesterId, branchId,
  successCallback, errorCallBack
) => {
  const data = { subjectId, sectionId, semesterId, branchId };
  return _fetchService(`deleteElectiveGroupedStudents`, 'POST', data, successCallback, errorCallBack);
};


// export const SemSubjectShowdata = (successCallback, errorCallBack) => _fetchService('semSubject/showData', 'GET', {}, successCallback, errorCallBack);

export const SemSubjectDelete = (data, successCallback, errorCallBack) => _fetchService(`semSubject/${data.id}/delete`, 'POST', data, successCallback, errorCallBack);

export const SemSubjecUpdate = (data, successCallback, errorCallBack) => _fetchService(`semSubject/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const GetSubject = (data,successCallback, errorCallBack) => _fetchService(`getSubject/${data.id}`, 'GET', {}, successCallback, errorCallBack);

export const SemSubjectAdd = (data,successCallback, errorCallBack) => _fetchService('semSubject/add', 'POST', data, successCallback, errorCallBack);

export const SemSubjectShowData = (data,successCallback, errorCallBack) => _fetchService('semSubject/showData', 'POST', data, successCallback, errorCallBack);

export const FetchMergedStudentViewData = (data,successCallback, errorCallBack) => _fetchService('showMergedStudents', 'POST', data, successCallback, errorCallBack);

//////------Student------///////

export const StudentNo = (successCallback, errorCallBack) => _fetchService('student/studentNo', 'GET', {}, successCallback, errorCallBack);

export const StudentAdd = (data, successCallback, errorCallBack) => _fetchService('student/add', 'POST', data, successCallback, errorCallBack);

export const StudentUpdate = (data, successCallback, errorCallBack) => _fetchService(`student/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const StudentDelete = (id, successCallback, errorCallBack) => _fetchService(`student/${id}/delete`, 'POST', {}, successCallback, errorCallBack);

export const StudentShowdata = (successCallback, errorCallBack) => _fetchService('student/showData', 'GET', {}, successCallback, errorCallBack);

export const StudentBulk = (data, successCallback, errorCallBack) => _fetchService('student/import', 'POST', data, successCallback, errorCallBack);

export const  FetchStudentLabelService = (successCallback, errorCallBack) => _fetchService('student/labelShow', 'GET', {}, successCallback, errorCallBack);

export const  LabelStudentAddService = (data, successCallback, errorCallBack) => _fetchService('student/label', 'POST', data, successCallback, errorCallBack);

export const  LabelStudentDeletService = (id,successCallback, errorCallBack) => _fetchService(`student/${id}/labelDelete`, 'POST', {}, successCallback, errorCallBack);

export const FetchSectionShowData = (data,successCallback, errorCallBack) => _fetchService(`getSection/${data.id}`, 'GET', {}, successCallback, errorCallBack);

export const FetchStudentListByFilters = (data, successCallback, errorCallBack) => _fetchService('showDataStudent', 'POST', data, successCallback, errorCallBack);

///---- Attendence------/////

export const AttendenceBulk = (data, successCallback, errorCallBack) => _fetchService('attendence/import', 'POST', data, successCallback, errorCallBack);

export const GetAttendenceView = (data, successCallback, errorCallBack) => _fetchService('attendence/getAttendence', 'POST', data, successCallback, errorCallBack);

export const AttendenceUpdate = (data, successCallback, errorCallBack) => _fetchService(`attendence/updateSMSSendORNot`, 'POST', data, successCallback, errorCallBack);

export const AttendenceAbsent = ( successCallback, errorCallBack) => _fetchService('attendence/absent', 'GET', {}, successCallback, errorCallBack);

export const SendBulkSms = (data, successCallback, errorCallBack) => _fetchService(`attendence/AllUpdateSMSSendORNot`, 'POST', data, successCallback, errorCallBack);

export const DeviceAlert = ( successCallback, errorCallBack) => _fetchService('systemAlertsLog', 'GET', {}, successCallback, errorCallBack);

/////-----Live Attendance-----/////

export const LiveAttendenceView = (data, successCallback, errorCallBack) => _fetchService('attendence/getLive', 'POST', data, successCallback, errorCallBack);

export const DisconnectedAttDvce = (successCallback, errorCallBack) => _fetchService('attendence/disCon', 'GET', {}, successCallback, errorCallBack);

export const GetDisConnDev = (data, successCallback, errorCallBack) => _fetchService(`attendence/${data.id}/disConFac`, 'GET', data, successCallback, errorCallBack);

//////----Report-----///////

export const GetSubjectReport = (data,successCallback, errorCallBack) => _fetchService(`getSub/${data.id}`, 'GET', {}, successCallback, errorCallBack);

export const  GetSectionReport = (data, successCallback, errorCallBack) => _fetchService('report/getSectionList', 'POST', data, successCallback, errorCallBack);

/////----- Student Report------/////

export const GetStudentReportView = (data, successCallback, errorCallBack) => _fetchService('report/getAttendanceReport', 'POST', data, successCallback, errorCallBack);
// export const GetStudentReportView = (data, successCallback, errorCallBack) => _fetchService('report/getAttendanceReport2Attendance', 'POST', data, successCallback, errorCallBack);


export const GetSemWiseReportView = (data, successCallback, errorCallBack) => _fetchService('report/getReportMonthWise', 'POST', data, successCallback, errorCallBack);

export const GetStudentWiseReportView = (data, successCallback, errorCallBack) => _fetchService('studentWiseAttendanceReport', 'POST', data, successCallback, errorCallBack);

/////----Faculty Report----/////

export const GetFacultyReportView = (data, successCallback, errorCallBack) => _fetchService('report/facultyReport', 'POST', data, successCallback, errorCallBack);

////----Studnet Transfer----/////

export const StudentTransferShowdata = (data, successCallback, errorCallBack) => _fetchService('student/beforeTransfer/showData', 'POST', data, successCallback, errorCallBack);

export const StudentGetSemester = (data, successCallback, errorCallBack) => _fetchService('student/getSemester', 'POST', data, successCallback, errorCallBack);

export const StudentGetSection = (data, successCallback, errorCallBack) => _fetchService('student/getSection', 'POST', data, successCallback, errorCallBack);

export const StudentTransferData = (data, successCallback, errorCallBack) => _fetchService('student/transfer', 'POST', data, successCallback, errorCallBack);

export const StudentTransferLogShowdata = (successCallback, errorCallBack) => _fetchService('student/transferedData', 'GET', {}, successCallback, errorCallBack);

export const StudentTransferIsCheck = (data, successCallback, errorCallBack) => _fetchService(`student/${data.id}/isCheck`, 'POST', data, successCallback, errorCallBack);

export const StudentCheckAll = (data, successCallback, errorCallBack) => _fetchService('student/checkAll', 'POST', data, successCallback, errorCallBack);


export const PostMergedStudentList = (data, successCallback, errorCallBack) => _fetchService('MapElectiveSubjectStudent', 'POST', data, successCallback, errorCallBack);

/////------History----//////

export const StudentHistoryShowdata = (successCallback, errorCallBack) => _fetchService('student/histroy/showData', 'GET', {}, successCallback, errorCallBack);

export const FacultyHistoryShowdata = (successCallback, errorCallBack) => _fetchService('faculty/histroy/showData', 'GET', {}, successCallback, errorCallBack);

/////-------User-----/////

export const StudentUserAdd = (data, successCallback, errorCallBack) => _fetchService('user/add', 'POST', data, successCallback, errorCallBack);

export const StudentUserUpdate = (data, successCallback, errorCallBack) => _fetchService(`user/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const StudentUserDelete = (id, successCallback, errorCallBack) => _fetchService(`user/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const StudentUserShowdata = (successCallback, errorCallBack) => _fetchService('user/showData', 'GET', {}, successCallback, errorCallBack);

/////-----Student Dashboard------/////

export const StudDashboardCount = (data, successCallback, errorCallBack) => _fetchService('countData2', 'POST', data, successCallback, errorCallBack);

export const StudentCardDashCount = (data, successCallback, errorCallBack) => _fetchService('dashBoard/countShowData', 'POST', data, successCallback, errorCallBack);

export const FacultyCardDashCount = (data, successCallback, errorCallBack) => _fetchService('AttandanceTakenLog', 'POST', data, successCallback, errorCallBack);

export const StudentCardCountBranch = (data, successCallback, errorCallBack) => _fetchService('dashBoard/countBranch', 'POST', data, successCallback, errorCallBack);

export const StudentDashSubLit = (data, successCallback, errorCallBack) => _fetchService('dashBoard/subList', 'POST', data, successCallback, errorCallBack);



export const GetCourseShowData = (successCallback, errorCallBack) => _fetchService('faculty/courseList', 'POST', {}, successCallback, errorCallBack);

export const GetSpecializationShowData = (data, successCallback, errorCallBack) => _fetchService(`faculty/${data.id}/specializeList`, 'POST', {}, successCallback, errorCallBack);

export const GetSectionShowData = (data, successCallback, errorCallBack) => _fetchService(`faculty/${data.id}/sectionList`, 'POST', {}, successCallback, errorCallBack);

export const GetSemesterShowData = (data, successCallback, errorCallBack) => _fetchService(`faculty/${data.id}/semList`, 'POST', {}, successCallback, errorCallBack);

export const GetSubjectShowData = (data, successCallback, errorCallBack) => _fetchService(`faculty/${data.id}/subList`, 'POST', {}, successCallback, errorCallBack);

export const GetSubjectGraphShowData = (data, successCallback, errorCallBack) => _fetchService(`subjectList`, 'POST', data, successCallback, errorCallBack);


export const FetchClassTypeShowData = ( successCallback, errorCallBack) => _fetchService(`classType/showData`, 'GET', {}, successCallback, errorCallBack);

export const AbsentStatus = (data, successCallback, errorCallBack) => _fetchService(`subjectAbsentsList`, 'POST', data, successCallback, errorCallBack);

export const PresentStatus = (data, successCallback, errorCallBack) => _fetchService(`TodayAttendancePerSubject`, 'POST', data, successCallback, errorCallBack);

export const ClassesSubStatus = (data, successCallback, errorCallBack) => _fetchService(`AbsentListByRange`, 'POST', data, successCallback, errorCallBack);


export const DaysSubStatus = (data, successCallback, errorCallBack) => _fetchService(`StudentContinuesAbsenceHistogram`, 'POST', data, successCallback, errorCallBack);

export const attendanceData = (data, successCallback, errorCallBack) => _fetchService('report/dayWiseAttendanceAllSubject ', 'POST', data, successCallback, errorCallBack);

export const GetReportModification = (data, successCallback, errorCallBack) => _fetchService('studentWiseAttendanceModification', 'POST', data, successCallback, errorCallBack);

export const EditReport= (data, successCallback, errorCallBack) => _fetchService('AttandanceUpdate', 'POST', data, successCallback, errorCallBack);

export const GetAttendeceShortageReportView = (data, successCallback, errorCallBack) => _fetchService('report/getReportAttendanceShortage', 'POST', data, successCallback, errorCallBack);

export const  SearchStudentOption = (data, successCallback, errorCallBack) => _fetchService('student/showStudentList', 'POST', data, successCallback, errorCallBack);

export const  ModificationStatus = (data, successCallback, errorCallBack) => _fetchService('showAttendanceModifiedData', 'POST', data, successCallback, errorCallBack);

export const MedicalLeaveUpdate = (data, successCallback, errorCallBack) => _fetchService(`studentExtraAttendance/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const GetMedicalLeaveShowData = (successCallback, errorCallBack) => _fetchService('studentExtraAttendance/showData', 'GET', {}, successCallback, errorCallBack);

export const MedicalLeaveDelete = (id, successCallback, errorCallBack) => _fetchService(`studentExtraAttendance/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const GetClassStatusReportView = (data, successCallback, errorCallBack) => _fetchService('report/attendancesLog', 'POST', data, successCallback, errorCallBack);

export const RemedialClassSubmit = (data, successCallback, errorCallBack) => _fetchService('MapRemedialStudent', 'POST', data, successCallback, errorCallBack);

export const UserUpload = (data, successCallback, errorCallBack) => _fetchService('user/import', 'POST', data, successCallback, errorCallBack);




























export const GetCountService = (successCallback, errorCallBack) => _fetchService('getCount', 'GET', {}, successCallback, errorCallBack);

export const DashBoardGetDelCountService = (successCallback, errorCallBack) => _fetchService('dashBoard/getDelCount', 'GET', {}, successCallback, errorCallBack);

export const DashBoardShowDataService = (successCallback, errorCallBack) => _fetchService('dashBoard/delShowData', 'GET', {}, successCallback, errorCallBack);

export const ReceiveOTPService = (data, successCallback, errorCallBack) => _fetchService('sendOtp', 'POST', data, successCallback, errorCallBack);

export const ValidateOTPService = (data, successCallback, errorCallBack) => _fetchService('requestToken', 'POST', data, successCallback, errorCallBack);

export const FetchCustomerService = (successCallback, errorCallBack) => _fetchService('customer/showData', 'GET', {}, successCallback, errorCallBack);

export const FetchEmployees = (successCallback, errorCallBack) => _fetchService('empuser', 'GET', {}, successCallback, errorCallBack);

export const FetchCustomer = (successCallback, errorCallBack) => _fetchService('getCustomer', 'GET', {}, successCallback, errorCallBack);

export const  GetCustomershow = ( successCallback, errorCallBack) => _fetchService('getCustomer', 'GET',{}, successCallback, errorCallBack);

export const GetVendorshow = ( successCallback, errorCallBack) => _fetchService('getVendor', 'GET',{}, successCallback, errorCallBack);

export const DeliveryDeleteService = (id, successCallback, errorCallBack) => _fetchService(`delivery/${id}/delete`, 'POST',{}, successCallback, errorCallBack);

export const DashBoardService = (successCallback, errorCallBack) => _fetchService('dashBoard/getPie', 'GET',{}, successCallback, errorCallBack);

// --------- User--------------//
export const FetchUserService = (successCallback, errorCallBack) => _fetchService('user/showData', 'GET', {}, successCallback, errorCallBack);

export const UserAddService = (data, successCallback, errorCallBack) => _fetchService('user/add', 'POST', data, successCallback, errorCallBack);

export const UserUpdateService = (data, successCallback, errorCallBack) => _fetchService(`user/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const UserDeleteService = (data, successCallback, errorCallBack) => _fetchService(`user/${data.id}/delete`, 'POST', data, successCallback, errorCallBack);

// --- Unblock user ----//
export const UnblockUserService = (data, successCallback, errorCallBack) => _fetchService('blockedUserPasswordAutogenerate', 'POST', data, successCallback, errorCallBack);

/////-----Dispatch-----//////

export const DispatchService = (successCallback, errorCallBack) => _fetchService('dispatchData', 'GET', {}, successCallback, errorCallBack);

export const ViewSummeryService = (data,successCallback, errorCallBack) => _fetchService(`getDeliveryData/${data.id}`, 'GET', {}, successCallback, errorCallBack);

export const AddVehicleNoService = (data, successCallback, errorCallBack) => _fetchService(`delivery/${data.id}/addVechileNo`, 'POST', data, successCallback, errorCallBack);

export const UpdateStatus = (data, successCallback, errorCallBack) => _fetchService('updateStatus', 'POST', data, successCallback, errorCallBack);

export const SubmitDispatch = (data, successCallback, errorCallBack) => _fetchService('submitDispatch', 'POST', data, successCallback, errorCallBack);

/////...dispatch vendor ........./////

export const VendorDispatch = (data, successCallback, errorCallBack) => _fetchService(`venDispatch/${data.id}/getPartQr`, 'POST', data, successCallback, errorCallBack);

export const VendorDispatchUpdateQr = (data, successCallback, errorCallBack) => _fetchService(`venDispatch/${data.id}/updateQr`, 'POST', data, successCallback, errorCallBack);

export const VendorDispatchShortageQr = (data, successCallback, errorCallBack) => _fetchService(`venDispatch/${data.id}/shortage`, 'POST', data, successCallback, errorCallBack);

///........Dispatch Super...////

export const DispSupShowData = (successCallback, errorCallBack) => _fetchService('dispSup/showData', 'GET', {}, successCallback, errorCallBack);

export const DispSupSubmit = (data,successCallback, errorCallBack) => _fetchService('dispSupSubmit', 'POST', data, successCallback, errorCallBack);

export const DispSupCheck = (data,successCallback, errorCallBack) => _fetchService('dispSupCheck', 'POST', data, successCallback, errorCallBack);

export const SubmitSupervisor = (data,successCallback, errorCallBack) => _fetchService('submitSupervisor', 'POST', data, successCallback, errorCallBack);

export const DispSupStatusUpdate = (data,successCallback, errorCallBack) => _fetchService('dispSupStatus/update', 'POST', data, successCallback, errorCallBack);

export const VendorDispSupCheck = (data,successCallback, errorCallBack) => _fetchService('venDispSup/checkUpdate', 'POST', data, successCallback, errorCallBack);

export const VendorDispSupCheckApprove = (data,successCallback, errorCallBack) => _fetchService('venDispSup/approveSup', 'POST', data, successCallback, errorCallBack);

///........QR Code .......////

export const QRcodeResultService = (data,successCallback, errorCallBack) => _fetchService(`getPartQr/${data.id}`, 'POST', data, successCallback, errorCallBack);

///....... Create DC..../////

export const CreateDcShowService = (successCallback, errorCallBack) => _fetchService('dc/showData', 'GET', {}, successCallback, errorCallBack);

export const CreateDcAutoService = (successCallback, errorCallBack) => _fetchService('dc/dcRefNo', 'GET', {}, successCallback, errorCallBack);

export const CustomerDCAddService = (data, successCallback, errorCallBack) => _fetchService('dc/add', 'POST', data, successCallback, errorCallBack);

export const UpdateDCAddService = (data, successCallback, errorCallBack) => _fetchService(`dc/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const DcDeleteService = (id, successCallback, errorCallBack) => _fetchService(`dc/${id}/delete`, 'POST',{}, successCallback, errorCallBack);

export const DcGetPartType = (data, successCallback, errorCallBack) => _fetchService(`getPartType/${data.id}`, 'GET',{}, successCallback, errorCallBack);

export const getPartData = (data, successCallback, errorCallBack) => _fetchService(`getPartData/${data.id}`, 'GET',{}, successCallback, errorCallBack);

// ------------- Customer -----------//
export const CustomerAddService = (data, successCallback, errorCallBack) => _fetchService('customer/add', 'POST', data, successCallback, errorCallBack);

export const CustomerEditService = (data, successCallback, errorCallBack) => _fetchService(`customer/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const CustomerDeleteService = (data, successCallback, errorCallBack) => _fetchService(`customer/${data.id}/delete`, 'POST', data, successCallback, errorCallBack);

export const PasswordResetService = (data, successCallback, errorCallBack) => _fetchService('resetUserPassword', 'POST', data, successCallback, errorCallBack);

export const GetCustomerService = (successCallback, errorCallBack) => _fetchService('getCustomer', 'GET', {}, successCallback, errorCallBack);

export const GetVendorService = (successCallback, errorCallBack) => _fetchService('getVendor', 'GET', {}, successCallback, errorCallBack);

// ------------ Vendor --------
export const VendorDeleteService = (id, successCallback, errorCallBack) => _fetchService(`vendor/${id}/delete`, 'POST', {}, successCallback, errorCallBack);

export const VendorEditService = (data, successCallback, errorCallBack) => _fetchService(`vendor/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const FetchVendorService = (successCallback, errorCallBack) => _fetchService('vendor/showData', 'GET', {}, successCallback, errorCallBack);

export const VendorAddService = (data, successCallback, errorCallBack) => _fetchService('vendor/add', 'POST', data, successCallback, errorCallBack);

export const GetSalesDatailService = (data,successCallback, errorCallBack) => _fetchService(`delivery/${data.id}/getsalesRefNoData`, 'GET', {}, successCallback, errorCallBack);


///..........delivery...........//

export const FetchDeliveryShowData = (successCallback, errorCallBack) => _fetchService('delivery/showData', 'GET', {}, successCallback, errorCallBack);

export const SalesDeliveryShowData = (successCallback, errorCallBack) => _fetchService('sales/getSalesRefNo', 'GET', {}, successCallback, errorCallBack);

export const FilteredSalesDeliveryShowData = (data, successCallback, errorCallBack) => _fetchService(`delivery/getCustomerSales`, 'POST', data, successCallback, errorCallBack);

export const FetchDeliveryId = (successCallback, errorCallBack) => _fetchService('delivery/scheduleNo', 'GET', {}, successCallback, errorCallBack);


export const FetchAddDeliveryService = (data,successCallback, errorCallBack) => _fetchService('delivery/add', 'POST', data, successCallback, errorCallBack);

export const FetchUpdateDeliveryService = (data,successCallback, errorCallBack) => _fetchService(`delivery/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const DeliveryListService = (data,successCallback, errorCallBack) => _fetchService('deliveryList/add', 'POST', data, successCallback, errorCallBack);

export const AddGRNNoService = (data,successCallback, errorCallBack) => _fetchService(`delivery/${data.id}/addGrnNo`, 'POST', data, successCallback, errorCallBack);

//---------- DeliveryPartList -------------//

export const FetchDeliveryPartList = (id, successCallback, errorCallBack) => _fetchService(`deliveryList/${id}/showList`, 'GET', {}, successCallback, errorCallBack);

export const DeleteDeliveryPartList = (id, successCallback, errorCallBack) => _fetchService(`deliveryList/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const UpdateDeliveryPartList = (data,successCallback, errorCallBack) => _fetchService(`deliveryList/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

///.........category..../////

export const CategoryAdd = (data, successCallback, errorCallBack) => _fetchService('category/add', 'POST', data, successCallback, errorCallBack);

export const CategoryUpdate = (data, successCallback, errorCallBack) => _fetchService(`category/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const CategoryDelete = (id, successCallback, errorCallBack) => _fetchService(`category/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const CategoryShow = (successCallback, errorCallBack) => _fetchService('category/showData', 'GET', {}, successCallback, errorCallBack);

/////............project......////

export const ProjectAdd = (data, successCallback, errorCallBack) => _fetchService('project/add', 'POST', data, successCallback, errorCallBack);

export const ProjectUpdate = (data, successCallback, errorCallBack) => _fetchService(`project/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const ProjectDelete = (id, successCallback, errorCallBack) => _fetchService(`project/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const ProjectShow = (successCallback, errorCallBack) => _fetchService('project/showData', 'GET', {}, successCallback, errorCallBack);



//-Duplicate Part-//

export const FetchDeliveryScheduleNoList = (successCallback, errorCallBack) => _fetchService('delivery/getdeliveryScheduleNo', 'GET', {}, successCallback, errorCallBack);

export const AddDuplicatePartList = (data,successCallback, errorCallBack) => _fetchService('deliveryList/updateDeliveryScheduleNo', 'POST', data, successCallback, errorCallBack);

//------------------------------------//
export const FetchPartDataService = (data,successCallback, errorCallBack) => _fetchService(`getPartData/${data.id}`, 'GET', {}, successCallback, errorCallBack);

export const DeliveryListDataService = (data,successCallback, errorCallBack) => _fetchService('deliveryList/showData', 'GET', {}, successCallback, errorCallBack);

/////-------Add Sales-----////////

export const SalesAddService = (data, successCallback, errorCallBack) => _fetchService('sales/add', 'POST', data, successCallback, errorCallBack);

export const SalesUpdateService = (data, successCallback, errorCallBack) => _fetchService(`sales/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const SalesDeleteService = (id, successCallback, errorCallBack) => _fetchService(`sales/${id}/delete`, 'POST',{}, successCallback, errorCallBack);

export const FetchSaleService = (successCallback, errorCallBack) => _fetchService('sales/showData', 'GET', {}, successCallback, errorCallBack);

export const FetchGenerateId = (successCallback, errorCallBack) => _fetchService('sales/generateId', 'GET', {}, successCallback, errorCallBack);

export const SaleGetRefNo = (successCallback, errorCallBack) => _fetchService('sales/getSalesRefNo', 'GET', {}, successCallback, errorCallBack);

export const SaleGetRefNoData = (data,successCallback, errorCallBack) => _fetchService(`sales/${data.id}/getData`, 'GET', {}, successCallback, errorCallBack);

export const SaleParId = (successCallback, errorCallBack) => _fetchService('part/getPartId', 'GET', {}, successCallback, errorCallBack);

export const SaleParIdIgame = (successCallback, errorCallBack) => _fetchService(`part/${data.id}/getFile`, 'GET', {}, successCallback, errorCallBack);

export const ParIdImage = (data,successCallback, errorCallBack) => _fetchService(`sales/${data.id}/getFile`, 'GET', {}, successCallback, errorCallBack);

export const GetProjects = (data,successCallback, errorCallBack) => _fetchService(`getProjects/${data.id}`, 'GET', {}, successCallback, errorCallBack);

export const SaleGetPartId = (data,successCallback, errorCallBack) => _fetchService(`sales/${data.id}/getPartId`, 'GET', {}, successCallback, errorCallBack);

export const DeliveryGetPartId = (data,successCallback, errorCallBack) => _fetchService(`delivery/${data.id}/partData`, 'GET', {}, successCallback, errorCallBack);

export const SalesPartAdd = (data, successCallback, errorCallBack) => _fetchService('salePartList/add', 'POST', data, successCallback, errorCallBack);

export const SalePartList = (data,successCallback, errorCallBack) => _fetchService(`salePartList/${data.id}/showList`, 'GET', {}, successCallback, errorCallBack);

export const SalesPartUpdate = (data, successCallback, errorCallBack) => _fetchService(`salePartList/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const DeleteSalesPartList = (data, successCallback, errorCallBack) => _fetchService(`salePartList/${data.id}/delete`, 'POST', {}, successCallback, errorCallBack);

export const SalePartListDuplicate = (data, successCallback, errorCallBack) => _fetchService('salePartList/duplicate', 'POST', data, successCallback, errorCallBack);

export const SalePartListImport = (data, successCallback, errorCallBack) => _fetchService('sales/import', 'POST', data, successCallback, errorCallBack);

// ---------------------- Location -----------------
export const FetchLocationService = (successCallback, errorCallBack) => _fetchService('search', 'POST', {}, successCallback, errorCallBack);

export const LocationAddService = (data, successCallback, errorCallBack) => _fetchService('location/add', 'POST', data, successCallback, errorCallBack);

export const LocationEditService = (data, successCallback, errorCallBack) => _fetchService(`location/${data.locationId}/update`, 'POST', data, successCallback, errorCallBack);

export const LocationDeleteService = (id, successCallback, errorCallBack) => _fetchService(`location/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

// -------------------- Branch ----------------------
export const FetchBranchService = (data, successCallback, errorCallBack) => _fetchService('search', 'POST', data, successCallback, errorCallBack);

export const BranchAddService = (data, successCallback, errorCallBack) => _fetchService('branch/add', 'POST', data, successCallback, errorCallBack);

export const BranchEditService = (data, successCallback, errorCallBack) => _fetchService(`branch/${data.branch_id}/update`, 'POST', data, successCallback, errorCallBack);

export const BranchDeleteService = (id, successCallback, errorCallBack) => _fetchService(`branch/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

// --------------- Facility ---------------
export const FetchFacilitiyService = (data, successCallback, errorCallBack) => _fetchService('search', 'POST', data, successCallback, errorCallBack);

export const FacilitiyAddService = (data, successCallback, errorCallBack) => _fetchService('facility/add', 'POST', data, successCallback, errorCallBack);

export const FacilityEditService = (data, successCallback, errorCallBack) => _fetchService(`facility/${data.facilityId}/update`, 'POST', data, successCallback, errorCallBack);

export const FacilityDeleteService = (id, successCallback, errorCallBack) => _fetchService(`facility/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

// ----------- Building -------------
export const BuildingFetchService = (data, successCallback, errorCallBack) => _fetchService('search', 'POST', data, successCallback, errorCallBack);

export const BuildingAddService = (data, successCallback, errorCallBack) => _fetchService('building/add', 'POST', data, successCallback, errorCallBack);

export const BuildingEditService = (data, successCallback, errorCallBack) => _fetchService(`building/${data.buildingId}/update`, 'POST', data, successCallback, errorCallBack);

export const BuildingDeleteService = (id, successCallback, errorCallBack) => _fetchService(`building/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

// ----------- Floor -------------
export const FloorfetchService = (data, successCallback, errorCallBack) => _fetchService('search', 'POST', data, successCallback, errorCallBack);

export const FloorAddService = (data, successCallback, errorCallBack) => _fetchService('floor/add', 'POST', data, successCallback, errorCallBack);

export const FloorEditService = (data, successCallback, errorCallBack) => _fetchService(`floor/${data.floor_id}/update`, 'POST', data, successCallback, errorCallBack);

export const FloorDeleteService = (id, successCallback, errorCallBack) => _fetchService(`floor/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

// ------------ Lab --------------
export const LabfetchService = (data, successCallback, errorCallBack) => _fetchService('search', 'POST', data, successCallback, errorCallBack);

export const LabAddService = (data, successCallback, errorCallBack) => _fetchService('labDepartment/add', 'POST', data, successCallback, errorCallBack);

export const LabEditService = (data, successCallback, errorCallBack) => _fetchService(`labDepartment/${data.labid}/update`, 'POST', data, successCallback, errorCallBack);

export const LabDeleteService = (id, successCallback, errorCallBack) => _fetchService(`labDepartment/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

export const FetchCategoryService = (successCallback, errorCallBack) => _fetchService('category', 'GET', {}, successCallback, errorCallBack);

export const FetchDeviceLocationService = (successCallback, errorCallBack) => _fetchService('deviceloc', 'GET', {}, successCallback, errorCallBack);

export const AddDeviceLocationService = (data, successCallback, errorCallBack) => _fetchService('deviceloc/add', 'POST', data, successCallback, errorCallBack);

export const EditDeviceLocationService = (data, successCallback, errorCallBack) => _fetchService(`deviceloc/${data.devicelocationId}/update`, 'POST', data, successCallback, errorCallBack);

export const DeleteDeviceLocationService = (successCallback, errorCallBack, data) => _fetchService(`deviceloc/${data.id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

// -------- Category -------------
export const CategoryFetchService = (successCallback, errorCallBack) => _fetchService('category', 'GET', {}, successCallback, errorCallBack);

export const CategoryAddService = (data, successCallback, errorCallBack) => _fetchService('category/add', 'POST', data, successCallback, errorCallBack);

export const CategoryEditService = (data, successCallback, errorCallBack) => _fetchService(`category/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const CategoryDeleteService = (id, successCallback, errorCallBack) => _fetchService(`category/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

// ---------- Device ---------
export const DeviceFetchService = (data, successCallback, errorCallBack) => _fetchService('search', 'POST', data, successCallback, errorCallBack);

export const DeviceAddService = (data, successCallback, errorCallBack) => _fetchService('device/add', 'POST', data, successCallback, errorCallBack);

export const DeviceEditService = (data, successCallback, errorCallBack) => _fetchService(`device/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const DeviceDeleteService = (id, successCallback, errorCallBack) => _fetchService(`device/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

////-------Add parts--------//////

export const PartAddService = (data, successCallback, errorCallBack) => _fetchService('part/add', 'POST', data, successCallback, errorCallBack);

export const PartUpdateService = (data, successCallback, errorCallBack) => _fetchService(`part/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const PartDeleteService = (id, successCallback, errorCallBack) => _fetchService(`part/${id}/delete`, 'POST', id, successCallback, errorCallBack);

export const PartService = (successCallback, errorCallBack) => _fetchService('part/showData', 'GET', {}, successCallback, errorCallBack);

// export const  GetCustomershow = ( successCallback, errorCallBack) => _fetchService('getCustomer', 'GET',{}, successCallback, errorCallBack);

// ------- Sensor category ---------------//
export const SensorCategoryFetchService = (successCallback, errorCallBack) => _fetchService('sensorCategory', 'GET', {}, successCallback, errorCallBack);

export const SensorCategoryAddService = (data, successCallback, errorCallBack) => _fetchService('sensorCategory/add', 'POST', data, successCallback, errorCallBack);

export const SensorCategoryEditService = (data, successCallback, errorCallBack) => _fetchService(`sensorCategory/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const SensorCategoryDeleteService = (id, successCallback, errorCallBack) => _fetchService(`sensorCategory/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);
// --------------- Sensor Adding ---------------------//

export const SensorAddService = (data, successCallback, errorCallBack) => _fetchService('sensorUnit/add', 'POST', data, successCallback, errorCallBack);

export const SensorEditService = (data, successCallback, errorCallBack) => _fetchService(`sensorUnit/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const SensorFetchService = (data, successCallback, errorCallBack) => _fetchService(`sensorUnit/${data}`, 'GET', {}, successCallback, errorCallBack);

export const SensorDeleteService = (id, successCallback, errorCallBack) => _fetchService(`sensorUnit/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

export const SensorListFetchService = (successCallback, errorCallBack) => _fetchService('sensorUnit', 'GET', {}, successCallback, errorCallBack);

// ------------ Sensor deploying ------------------//
export const SensorDeployAddService = (data, successCallback, errorCallBack) => _fetchService('sensor/add', 'POST', data, successCallback, errorCallBack);

export const SensorDeployEditService = (data, successCallback, errorCallBack) => _fetchService(`sensor/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const SensorDeployDeleteService = (id, successCallback, errorCallBack) => _fetchService(`sensor/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

export const SensorDeployFetchService = (data, successCallback, errorCallBack) => _fetchService('search', 'POST', data, successCallback, errorCallBack);

export const SensorPropertiesUpdateService = (data, successCallback, errorCallBack) => _fetchService(`sensorProperties/${data.id}/update`, 'POST', data, successCallback, errorCallBack);
// ------------ Config setup ------------------//

export const ConfigSetupFetchService = (successCallback, errorCallBack) => _fetchService('configSetup', 'GET', {}, successCallback, errorCallBack);

export const ConfigSetupAddService = (data, successCallback, errorCallBack) => _fetchService('configSetup/add', 'POST', data, successCallback, errorCallBack);

export const ConfigSetupEditService = (data, successCallback, errorCallBack) => _fetchService(`configSetup/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const ConfigSetupDeleteService = (id, successCallback, errorCallBack) => _fetchService(`configSetup/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

// ------------ Device Config setup ------------------//

export const DeviceConfigSetupAddService = (data, successCallback, errorCallBack) => _fetchService('DeviceConfigSetup/add', 'POST', data, successCallback, errorCallBack);

export const DeviceConfigSetupFetchService = (data, successCallback, errorCallBack) => { return _fetchService(`DeviceConfigSetup/${data.id}/getDeviceConfigData`, 'GET', {}, successCallback, errorCallBack); };

// ----------- STEL & TWA setup -----------------------//

export const StelEditService = (data, successCallback, errorCallBack) => { return _fetchService(`stel/${data.id}/update`, 'POST', data, successCallback, errorCallBack); };

// ------------ Change Device Mode -------------------//

export const ChangeDeviceMode = (data, successCallback, errorCallBack) => { return _fetchService(`deviceMode/${data.id}/update`, 'POST', data, successCallback, errorCallBack); };

// ------------- Dashboard Chart Display ------------//

export const DisplayLineChart = (successCallback, errorCallBack) => { return _fetchService('aqmiSensorValues', 'POST', {}, successCallback, errorCallBack); };

// ------------- Calibration Result ---------------//

export const CalibrationAddService = (data, successCallback, errorCallBack) => _fetchService('calibrationTestResult/add', 'POST', data, successCallback, errorCallBack);

// -------------DeployedSensor List --------------//
export const deviceDeployedSensors = (id, successCallback, errorCallBack) => _fetchService(`deviceDeployedSensors/${id}`, 'GET', {}, successCallback, errorCallBack);

// -------------DeployedSensorTable List --------------//
export const DeployedSensorsDetailsList = (data, successCallback, errorCallBack) => _fetchService('calibrationTestResult', 'POST', data, successCallback, errorCallBack);

// -------------BumpTest enabled sensors List --------------//
export const BumpTestEnabledSensors = (id, successCallback, errorCallBack) => _fetchService(`bumptestDeviceDeployedSensors/${id}`, 'GET', {}, successCallback, errorCallBack);

// ------------- Bump Test ----------------------------//
export const BumpTestAddService = (data, successCallback, errorCallBack) => _fetchService('bumpTestResult/add', 'POST', data, successCallback, errorCallBack);

export const BumpTestFetchService = (data, successCallback, errorCallBack) => _fetchService('bumpTestResult', 'POST', data, successCallback, errorCallBack);

// --------------User Logs ---------------------------//
export const FetchUserLogService = (data, successCallback, errorCallBack) => _fetchService('userListDetails', 'POST', data, successCallback, errorCallBack);

export const FetchUserLogDetails = (data, successCallback, errorCallBack) => _fetchService('userLog', 'POST', data, successCallback, errorCallBack);

// ----- Dashboard API ------------------------------- //

export const DashboardSensorListDetails = (data, successCallback, errorCallBack) => _fetchService('lastUpdatedData', 'POST', data, successCallback, errorCallBack);

export const DashboardIndividualSensorDetails = (data, successCallback, errorCallBack) => _fetchService('sensorTagIdData', 'POST', data, successCallback, errorCallBack);

export const DeviceIdAlerts = (data, successCallback, errorCallBack) => _fetchService('alertData', 'POST', data, successCallback, errorCallBack);

export const SensorIdAlertUpdate = (data, successCallback, errorCallBack) => _fetchService('alertDataUpdate', 'POST', data, successCallback, errorCallBack);

//-------------- Reports API-------------------------------//

export const FetchBumpTestReportDetails = (data, successCallback, errorCallBack) => _fetchService('reportBumpTest', 'POST', data, successCallback, errorCallBack);

export const FetchAlarmReportDetails = (data, successCallback, errorCallBack) => _fetchService('alarmReport', 'POST', data, successCallback, errorCallBack);

export const FetchSensorLogReportDetails = (data, successCallback, errorCallBack) => _fetchService('SensorLog', 'POST', data, successCallback, errorCallBack);

// export const FetchAqiStatusReportDetails = (data, successCallback, errorCallBack) => _fetchService('SiteDeviceReport', 'POST', data, successCallback, errorCallBack);

export const FetchFirmwareVersionReportDetails = (data, successCallback, errorCallBack) => _fetchService('FirmwareVersionReport', 'POST', data, successCallback, errorCallBack);

export const FetchHardwareVersionReportDetails = (data, successCallback, errorCallBack) => _fetchService('hardwareVersionLogsReports', 'POST', data, successCallback, errorCallBack);

export const FetchApplicationVersionReportDetails = (data, successCallback, errorCallBack) => _fetchService('appVersion', 'GET', data, successCallback, errorCallBack);

export const FetchAqiStatusReportDetails = (data, successCallback, errorCallBack) => _fetchService('DeviceAqiReport', 'POST', data, successCallback, errorCallBack);

export const FetchServerUsageReportDetails = (data, successCallback, errorCallBack) => _fetchService('serverUsage', 'POST', data, successCallback, errorCallBack);

export const FetchSensorStatusReportDetails = (data, successCallback, errorCallBack) => _fetchService('sensorStatusReport', 'POST', data, successCallback, errorCallBack);

// ---------- Alert Notification --------------------------//

export const NotificationAlerts = (data, successCallback, errorCallBack) => _fetchService('getAlerts', 'POST', data, successCallback, errorCallBack);

// ------------ Company Log Interval ---------------------//

export const CompanyLogInterval = (data, successCallback, errorCallBack) => { return _fetchService(`updateCustomerSettings`, 'POST', data, successCallback, errorCallBack); };

// ----------- Hooter Relay -----------------------------//

export const HooterRelayService = (data, successCallback, errorCallBack) => { return _fetchService(`labHooterRelay`, 'POST', data, successCallback, errorCallBack); };

export const TestHooterRelay = (data, successCallback, errorCallBack) => { return _fetchService(`testLabHooterRealay`, 'POST', data, successCallback, errorCallBack); };

// -------------Dynamic Unit listing --------------//
export const DynamicUnitListService = (id, successCallback, errorCallBack) => _fetchService(`sensorCategoryUnitsDisplay/${id}`, 'GET', {}, successCallback, errorCallBack);

// ------------ Application Version --------------//
export const AppVersionAddService = (data, successCallback, errorCallBack) => _fetchService('appVersion/add', 'POST', data, successCallback, errorCallBack);

export const AppVersionFetchService = (successCallback, errorCallBack) => _fetchService('appVersion', 'GET', {}, successCallback, errorCallBack);

export const AppVersionEditService = (data, successCallback, errorCallBack) => _fetchService(`appVersion/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const AppVersionDeleteService = (id, successCallback, errorCallBack) => _fetchService(`appVersion/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);

// ----------- Device Configuration / Firmware Upgradation / Debug --------//
export const TestModeChangeInitiator = (data, successCallback, errorCallBack) => { return _fetchService(`configurationStatus`, 'POST', data, successCallback, errorCallBack); };

export const ConfigUpgradeModeResult = (data, successCallback, errorCallBack) => { return _fetchService(`configurationProcessStatus`, 'POST', data, successCallback, errorCallBack); };

// ---------- Gas Cylinder ----------------//
export const GasCylinderFetchService = (successCallback, errorCallBack) => _fetchService('gasCylinder', 'GET', {}, successCallback, errorCallBack);

export const GasCylinderAddService = (data, successCallback, errorCallBack) => _fetchService('gasCylinder/add', 'POST', data, successCallback, errorCallBack);

export const GasCylinderEditService = (data, successCallback, errorCallBack) => _fetchService(`gasCylinder/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const GasCylinderDeleteService = (id, successCallback, errorCallBack) => _fetchService(`gasCylinder/${id}/delete`, 'DELETE', {}, successCallback, errorCallBack);


// --------- Email Template -------------//
export const EmailTemplateFetchService = (successCallback, errorCallBack) => _fetchService('emailTemplate', 'GET', {}, successCallback, errorCallBack);

export const EmailTemplateUpdateService = (data, successCallback, errorCallBack) => _fetchService('emailTemplate/update', 'POST', data, successCallback, errorCallBack);

// ------------ Back Up Configuration ---------------------//

export const BackUpConfigurationservice = (data, successCallback, errorCallBack) => { return _fetchService(`aidealabCompany/update`, 'POST', data, successCallback, errorCallBack); };

// ------------ Device Debug Result ---------------------//
export const DeviceDebugResultService = (data, successCallback, errorCallBack) => { return _fetchService(`DeviceDebugConfigData`, 'POST', data, successCallback, errorCallBack); };

// ------------ Fetch Device for Report ----------------//
export const SearchDeviceDataService = (data, successCallback, errorCallBack) => _fetchService('searchDeviceData', 'POST', data, successCallback, errorCallBack);

// ------------ Fetch Sensor AQI for Dashboard ----------------//
export const FetchSensorAQIService = (data, successCallback, errorCallBack) => _fetchService('getAqiReport', 'POST', data, successCallback, errorCallBack);

export const UpdateScannedCount = (data, successCallback, errorCallBack) => _fetchService(`updateQr/${data.id}`, 'POST', data, successCallback, errorCallBack);

export const UpdateScannedCountReason = (data, successCallback, errorCallBack) => _fetchService(`submitQr/${data.id}`, 'POST', data, successCallback, errorCallBack);


////......dc...........///

export const GetCategoryVendor = (data, successCallback, errorCallBack) => _fetchService(`getCategoryVendor/${data.id}`, 'GET', {}, successCallback, errorCallBack);

export const AddDcList = (data, successCallback, errorCallBack) => _fetchService('dcList/add', 'POST', data, successCallback, errorCallBack);

export const DcListShow = (data, successCallback, errorCallBack) => _fetchService(`dcList/${data.id}/showList`, 'GET', {}, successCallback, errorCallBack);

export const DcListDelete = (data, successCallback, errorCallBack) => _fetchService(`dcList/${data.id}/delete`, 'POST', {}, successCallback, errorCallBack);

export const DcListUpdate = (data, successCallback, errorCallBack) => _fetchService(`dcList/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const DispatchApproveSubmit = (data, successCallback, errorCallBack) => _fetchService('venDispatch/submit', 'POST', data, successCallback, errorCallBack);

export const vendorDispSupShowData = (successCallback, errorCallBack) => _fetchService('venDispSup/showData', 'GET', {}, successCallback, errorCallBack);


///...............stock ..............////

export const StockAdd = (data, successCallback, errorCallBack) => _fetchService('stock/add', 'POST', data, successCallback, errorCallBack);

export const StockUpdate = (data, successCallback, errorCallBack) => _fetchService(`stock/${data.id}/update`, 'POST', data, successCallback, errorCallBack);

export const StockShowData = (successCallback, errorCallBack) => _fetchService('stock/showData', 'GET', {}, successCallback, errorCallBack);

export const StockDelete= ( id,successCallback, errorCallBack) => _fetchService(`stock/${id}/delete`, 'POST', {}, successCallback, errorCallBack);

export const StockUpdatStkVal = (data, successCallback, errorCallBack) => _fetchService(`stock/${data.id}/updateStkVal`, 'POST', data, successCallback, errorCallBack);


/////..........invoice............./////

export const InvoiceUserShowData = (successCallback, errorCallBack) => _fetchService('invoiceUser/showData', 'GET', {}, successCallback, errorCallBack);

export const InvoiceUserStatusUpdate = (data,successCallback, errorCallBack) => _fetchService('invoiceUser/statusUpdate', 'POST', data, successCallback, errorCallBack);

export const InvoiceNumberStatusUpdate = (data,successCallback, errorCallBack) => _fetchService('invoice/add', 'POST', data, successCallback, errorCallBack);


/////..........XL....../////

export const SalesImport = (data,successCallback, errorCallBack) => _fetchService('sales/import', 'POST', data, successCallback, errorCallBack);

export const DeliveryImport = (data,successCallback, errorCallBack) => _fetchService('delivery/import', 'POST', data, successCallback, errorCallBack);

//////.......report.....////

export const IncStockShowData = (data,successCallback, errorCallBack) => _fetchService('incStock/showData', 'POST', data, successCallback, errorCallBack);

export const ShortageReportViwe = (data, successCallback, errorCallBack) => _fetchService('delShortage/showData', 'POST', data, successCallback, errorCallBack);

export const StockOpnClsShowData = (data, successCallback, errorCallBack) => _fetchService('stockOpnCls/showData', 'POST', data, successCallback, errorCallBack);

export const MonthReportViwe = (data, successCallback, errorCallBack) => _fetchService('monthReport/showData', 'POST', data, successCallback, errorCallBack);

export const DashBoardViwe = (data, successCallback, errorCallBack) => _fetchService('dashBoard/pieData', 'POST', data, successCallback, errorCallBack);

export const DashBoardGetShortage = (successCallback, errorCallBack) => _fetchService('dashBoard/getShortage', 'GET', {}, successCallback, errorCallBack);

export const DashBoardShortageData = (data, successCallback, errorCallBack) => _fetchService('dashBoard/shortageData', 'POST', data, successCallback, errorCallBack);

export const DashBoardGetBarData = (successCallback, errorCallBack) => _fetchService('dashBoard/getBar', 'GET', {}, successCallback, errorCallBack);

export const DashBoardGetShortagePierData = (successCallback, errorCallBack) => _fetchService('dashBoard/getShortagePie', 'GET', {}, successCallback, errorCallBack);

export const DashBoardBarChartData = (data,successCallback, errorCallBack) => _fetchService('dashBoard/barChartData', 'POST', data, successCallback, errorCallBack);

export const PartImport = (data,successCallback, errorCallBack) => _fetchService('part/import', 'POST', data, successCallback, errorCallBack);

export const MedicalLeaveAdd = (data, successCallback, errorCallBack) => _fetchService('studentExtraAttendance/add', 'POST', data, successCallback, errorCallBack);

export const RemedialStudentShowdata = (successCallback, errorCallBack) => _fetchService('showRemedialStudentsSubject', 'GET', {}, successCallback, errorCallBack);

export const StudentStudentDelete = (
  subjectId, sectionId, semesterId, branchId,
  successCallback, errorCallBack
) => {
  const data = { subjectId, sectionId, semesterId, branchId };
  return _fetchService(`deleteRemedialStudent`, 'POST', data, successCallback, errorCallBack);
};